// routes
import axios from 'axios';
import { Provider } from 'react-redux';
import { useEffect } from 'react';
import posthog from 'posthog-js';
import Router from './routes';
// theme
import ThemeConfig from './theme';
// components
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './context/AuthContext';
import { ImagePreviewProvider } from './context/ImagePreviewContext';
import makeStore from './redux';
import { generateNewAccessToken } from './service/auth.service';
import { addCke, delAllCke } from './helper/cookieHelper';
import NotistackProvider from './fl-components/NotistackProvider';
import toast from './SnackbarHelper';

import 'emoji-mart/css/emoji-mart.css';
import 'react-image-lightbox/style.css';
import 'react-quill/dist/quill.snow.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './app.css';
import { StoryPreviewProvider } from './context/StoryPreviewContext';
import { DiscoverSearchProvider } from './context/DiscoverSearchContext';
import { reportErrorViaWebhook } from './service/webhook.service';

axios.interceptors.response.use(
  (response) => {
    if (response?.data?.data) return response?.data.data;
    // if (response?.data) return response?.data;
    return response?.data;
  },
  (error) => {
    if (error.response) {
      reportErrorViaWebhook(
        error.response.data.message,
        `${error.response.config.baseURL}${error.response.config.url}`
      );
      if (error.response.data.code === 401) {
        // When user token is expires then we call this api to fetch new token
        generateNewAccessToken()
          .then((res) => {
            addCke('accessToken', res.access.token, res.access.expires);
            addCke('refreshToken', res.refresh.token, res.refresh.expires);
            // eslint-disable-next-line no-restricted-globals
            location.reload();
          })
          .catch(() => {
            delAllCke();
            // eslint-disable-next-line no-restricted-globals
            location.reload();
          });
      }
      toast.toast(error.response.data.message, {
        variant: 'error'
      });
    }
  }
);

export default function App() {
  useEffect(() => {
    posthog.init('phc_paVO6OPplSoPwuXFWSeT6rjlAXxNUWL7jCcRgPa1znT', {
      api_host: 'https://app.posthog.com',
      autocapture: true,
      capture_pageview: true,
      debug: false,
      session_recording: {
        maskAllInputs: true
      }
    });
  }, []);

  return (
    <Provider store={makeStore}>
      <NotistackProvider>
        <AuthProvider>
          <ImagePreviewProvider>
            <StoryPreviewProvider>
              <DiscoverSearchProvider>
                <ThemeConfig>
                  <ScrollToTop />
                  <Router />
                </ThemeConfig>
              </DiscoverSearchProvider>
            </StoryPreviewProvider>
          </ImagePreviewProvider>
        </AuthProvider>
      </NotistackProvider>
    </Provider>
  );
}
